import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"


export const initialState = {
  city: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  current_page: 1,
  per_page: PAGELENGTH,
}

export const citySlice = createSlice({
  name: 'city',
  initialState: initialState,
  reducers: {
    setCity: (state, { payload }) => {
      state.city = payload?.data ?? payload;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setCitys: (state, { payload }) => {
      state.city = payload?.data;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setMoreCitys: (state, { payload }) => {
      state.data = state.data.concat(payload.data);
      state.total = payload.total;
      state.is_more = payload.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setLunchSchedule: (state, { payload }) => {
      state.lunchSchedule = payload; // ✅ lunch schedule save karega
    },
    removeCity: (state, { payload }) => {
      state.error = payload
    },
    clearAllCity: (state, { payload }) => {
      state.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})

// const reducer = (state = initialState, action) => {
//   switch (action.type) {
//     case types.INIT_APP:
//     case types.GO_TO_DETAILS:
//       return { ...state, ...action.payload }
//     default:
//       return state
//   }
// }

export const addCity = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.addCity(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setCity(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}
export const addLunch = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}));
  dispatch(setLoader(true));
  try {
    const json = await Api.addLunch(data);
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message);
    } else if (json.status == 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    } else {
      callback(false, "Something went wrong");
    }
  } catch (error) {
    console.log(error);
    callback(false, "Server error");
  }
  dispatch(setLoader(false));
};
export const fetchLunchSchedule = (disableLoader, Aync) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true));
  try {
    const result = await Api.fetchLunchSchedule();
    if (result.status >= 200 && result.status < 300) {
      if (Aync) {
        return result.data;
      } else {
        dispatch(setLunchSchedule(result.data));
        !disableLoader && dispatch(setLoader(false));
      }
    } else if (result?.status == 422) {
      if (Aync) {
        return null;
      } else {
        dispatch(setError(result.data));
        !disableLoader && dispatch(setLoader(false));
      }
    }
  } catch (error) {
    console.log("fetchLunchSchedule error", error);
    !disableLoader && dispatch(setLoader(false));
  }
};
export const updateLunchStatus = (status, callback) => async (dispatch) => {
  try {
    const json = await Api.updateLunchStatus({ lunch_status: status });
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message);
    } else {
      callback(false, json?.data?.message || "Something went wrong");
    }
  } catch (error) {
    console.log(error);
    callback(false, "Server error");
  }
};


export const updateCity = (data, itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.updateCity(data, itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setCity(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const removeCity = (itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeCity(itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setCity(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}
export const fetchCitys = (page, params, disableLoader, Aync) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchCitys(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setCitys(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      } else {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setCitys(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      }
    }
    else if (result?.status == 422) {
      if (Aync) {
        return [];
      } else {
        dispatch(setError(result.data))
        !disableLoader && dispatch(setLoader(false))
      }
    }
  } catch (error) {
    console.log("error", error)
  }
}


export const changeStatus = (id, data) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.statusChange(id, data, 'city')
    if (json.status >= 200 && json.status < 300) {
      // console.log(json)
      // dispatch(setHospital(json.data))
      // callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      // callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const removeMultipleCitys = (ids, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeMultipleCitys(ids)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setHospital(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const { setCity, setCitys, clearAllCity, setLoader, setError, setMoreCitys, setLunchSchedule } = citySlice.actions


export default citySlice.reducer
export const citySelector = state => state.city


